import { Component } from "react";
import * as React from "react";
import { Switch } from "react-router";
import { Layout } from "./components/Layout";
import { PrivacyPolicy } from "./components/PrivacyPolicy";
import { GetStarted } from "./components/GetStarted";
import { AccountsGetStarted } from "./components/AccountsGetStarted";
import { AccountsAuthCallback } from "./components/AccountsAuthCallback";
import { PaymentsGetStarted } from "./components/PaymentsGetStarted";
import { PaymentsAuthCallback } from "./components/PaymentsAuthCallback";
import { MissionControl } from "./components/MissionControl";
import { Admin } from "./components/Admin";
import { AdminCreateMission } from "./components/AdminCreateMission";
import { TesterOnboarding } from "./components/TesterOnboarding";
import { TesterAgreement } from "./components/TesterAgreement";
import { AddBanks } from "./components/user/banks/AddBanks";
import { User } from "./components/User";
import "./style.css";
import { AdminManageUsers } from "./components/admin/users/AdminManageUsers";
import { AdminUserProfile } from "./components/admin/AdminUserProfile";
import { AdminManageUsersBanks } from "./components/admin/users/AdminManageUsersBanks";
import { AdminToken } from "./components/admin/AdminToken";
import { OpenAPI } from "./generated";
import { AdminViewMissions } from "./components/admin/AdminViewMissions";
import VrpsGetStarted from "./components/VrpsGetStarted";
import StageRoutingCallback from "./components/StageRoutingCallback";
import AdminRoute from "./components/ProtectedRoute";

export default class App extends Component {
  static displayName = App.name;

  constructor(props: {}) {
    super(props);
    OpenAPI.BASE = "";
  }

  render() {
    return (
      <Layout>
        <Switch>
          <AdminRoute exact path="/" component={User} />
          <AdminRoute exact path="/start" component={GetStarted} />
          <AdminRoute
            exact
            path="/accounts/start"
            component={AccountsGetStarted}
          />
          <AdminRoute
            exact
            path="/payments/start"
            component={PaymentsGetStarted}
          />
          <AdminRoute
            exact
            path="/accounts/auth-callback"
            component={AccountsAuthCallback}
          />
          <AdminRoute
            exact
            path="/payments/auth-callback"
            component={PaymentsAuthCallback}
          />
          <AdminRoute
            exact
            path="/stage-routing/callback"
            component={StageRoutingCallback}
          />
          <AdminRoute exact path="/vrps/start" component={VrpsGetStarted} />
          <AdminRoute
            exact
            path="/mission-control"
            component={MissionControl}
          />
          <AdminRoute
            exact
            path="/admin/create"
            component={AdminCreateMission}
          />
          <AdminRoute exact path="/admin" component={Admin} />
          <AdminRoute exact path="/onboarding" component={TesterAgreement} />
          <AdminRoute exact path="/user/edit" component={TesterOnboarding} />
          <AdminRoute exact path="/user/banks" component={AddBanks} />
          <AdminRoute exact path="/privacy-policy" component={PrivacyPolicy} />
          <AdminRoute exact path="/user" component={User} />
          {/* <Route exact path="/admin/invite" component={AdminCreateInvitation} /> */}
          <AdminRoute
            exact
            path="/admin/users/all"
            component={AdminManageUsers}
          />
          <AdminRoute
            exact
            path="/admin/users/invited"
            component={AdminManageUsers}
          />
          <AdminRoute
            exact
            path="/admin/users/active"
            component={AdminManageUsers}
          />
          <AdminRoute exact path="/admin/token" component={AdminToken} />
          <AdminRoute
            exact
            path="/admin/users/banks/:userEmail"
            component={AdminManageUsersBanks}
          />
          <AdminRoute
            exact
            path="/admin/user/:userEmail"
            component={AdminUserProfile}
          />
          <AdminRoute
            exact
            path="/admin/missions"
            component={AdminViewMissions}
          />
        </Switch>
      </Layout>
    );
  }
}
